import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, CheckboxControlValueAccessor } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ViewChildren, QueryList } from "@angular/core";
import { getPlatform } from "@angular/core/src/application_ref";
import { IMyDpOptions, IMyDateModel, IMyDate} from "mydatepicker";
import { PlanningService } from "../../_services/planning.service";
import { PlanningMessagesService } from "../../_services/planning-messages.service";
import { DateService } from "../../_services/date.service";
import { SecurityService } from "../../_services/security.service";
import { CityAutocompleteComponent } from "../city-autocomplete/city-autocomplete.component";
import { AreaAutocompleteComponent } from "../area-autocomplete/area-autocomplete.component";
import { CountryAutocompleteComponent } from "../country-autocomplete/country-autocomplete.component";
import { CompanyAutocompleteComponent } from "../company-autocomplete/company-autocomplete.component";
import { WarehouseAutocompleteComponent } from "../warehouse-autocomplete/warehouse-autocomplete.component";

import { ToastService } from "../../_services/toast.service";
import { Co2Service } from "../../_services/co2.service";
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

declare var jQuery: any;

import "../../../assets/semantic/semantic.min.js";
import * as moment from 'moment';

interface Filters {
  havetasks?: string;
  number?: string;
  state?: number;
  //state?: string | string[];
  client_id?: string;
  transporter_id?: string;
  receiver_id?: string;
  departure_city?: string;
  departure_area?: string;
  departure_country?: string;
  arrival_city?: string;
  arrival_area?: string;
  arrival_country?: string;
  quantity?: number;
  departure_date?: any;
  arrival_date?: any;
  buy_price?: number;
  sell_price?: number;
  note?: string;
  ref?: string;
  loading_hour?: string;
  shipping_hour?: string;
}

@Component({
  selector: "app-planning",
  templateUrl: "./planning.component.html",
  styleUrls: ["./planning.component.css"],
})
  
export class PlanningComponent implements OnInit {

  @ViewChildren('citycomp' ) childCity:QueryList<CityAutocompleteComponent>;
  @ViewChildren('areacomp' ) childArea: QueryList<AreaAutocompleteComponent>;
  @ViewChildren('countrycomp') childCountry: QueryList<CountryAutocompleteComponent>;
  @ViewChildren('companycomp') childCompany: QueryList<CompanyAutocompleteComponent>;
  @ViewChildren('warehousecomp') childWarehouse: QueryList<WarehouseAutocompleteComponent>;
  
  private is_admin: number = 0;
  private selectedDate: Date;

  private plannings: any[] = [];
  selectedPlanning: any = null;

  private plannings_count: number = 0;
  private full: number = 0;
  private grouped: number = 0;
  private monthly_margin: number = 0;
  private unread: Array<number> = [];
  private lates: number = 0;
  private todos: number = 0;
  private order: string = "departure_date asc";
  private hanging_planning;
  // Pagination variables
  private page_number: number;
  private page_count: number;
  private page_indicators: number[];
  private page_param: string;
  private isLate: boolean = false;
  private isUnreadFilterEnabled: boolean = false;

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "dd/mm/yyyy",
    openSelectorOnInputClick: true,
    editableDateField: false,
  };
  filters: FormGroup;

  constructor(
    private service: PlanningService,
    private planningMessagesService: PlanningMessagesService,
    private date_service: DateService,
    private route: ActivatedRoute,
    private router: Router,
    private security: SecurityService,
    private toast: ToastService,
    private co2Service: Co2Service
  ) {
    this.filters = new FormGroup({
      havetasks: new FormControl(),
      number: new FormControl(),
      state: new FormControl(),
      client_id: new FormControl(),
      transporter_id: new FormControl(),
      receiver_id: new FormControl(),
      departure_city: new FormControl(),
      departure_area: new FormControl(),
      departure_country: new FormControl(),
      arrival_city: new FormControl(),
      arrival_area: new FormControl(),
      arrival_country: new FormControl(),
      quantity: new FormControl(),
      departure_date: new FormControl(),
      arrival_date: new FormControl(),
      buy_price: new FormControl(),
      sell_price: new FormControl(),
      note: new FormControl(),
      ref: new FormControl(),
      loading_hour: new FormControl(),
      shipping_hour: new FormControl(),
    })
  }

  /*
  filters = new FormGroup({
    havetasks: new FormControl(),
    number: new FormControl(),
    state: new FormControl(),
    client_id: new FormControl(),
    transporter_id: new FormControl(),
    receiver_id: new FormControl(),
    departure_city: new FormControl(),
    departure_area: new FormControl(),
    departure_country: new FormControl(),
    arrival_city: new FormControl(),
    arrival_area: new FormControl(),
    arrival_country: new FormControl(),
    quantity: new FormControl(),
    departure_date: new FormControl(),
    arrival_date: new FormControl(),
    buy_price: new FormControl(),
    sell_price: new FormControl(),
    note: new FormControl(),
    ref: new FormControl(),
    loading_hour: new FormControl(),
    shipping_hour: new FormControl(),
  });
*/

  formatDate(date): string {
    moment.locale('fr');
    const formattedDate = moment(date, 'YYYY-MM-DD HH:mm:ss').format('ddd DD-MM-YYYY');
    return formattedDate || '';
  }

  ngOnInit() {
    
    this.selectedDate = new Date();
    this.getPlanning();
    
    //this.filters.valueChanges.debounceTime(250).subscribe((value) => {
    this.filters.valueChanges.pipe(debounceTime(800), distinctUntilChanged()).subscribe((value: Filters) => {
      //reset to first page vu qu'on change les filtres et qu'il y a une new requete.
      this.page_number = 1;
      // Check Departure & Arrival places Values:
      // If there is a departure_id city, clear the area & country inputs.
      if (value.departure_city) {
        this.filters.patchValue({
          departure_area: null,
          departure_country: null,
        });
      }
      // If there is a departure_id area, clear the country input
      if (value.departure_area) {
        this.filters.patchValue({ departure_country: null });
      }
      // If there is an arrival_id city, clear the area & country inputs
      if (value.arrival_city) {
        this.filters.patchValue({ arrival_area: null, arrival_country: null });
      }
      // If there is an arival area, clear the country input.
      if (value.arrival_area) {
        this.filters.patchValue({ arrival_country: null });
      }

      if (!value.state) value.state = undefined;
      //TODO: fix filter state
      /*if (["9", "11", "4", "5", "6", "7", "8"].includes(value.state as string)) {
        value.state = ["9", "11", "4", "5", "6", "7", "8"];
      }*/


      if (value.departure_date && value.departure_date.formatted) {
        //si on choisi une date ds les filtres, on change la date du haut (année/mois        
        this.selectedDate = value.departure_date.jsdate;
        value.departure_date = value.departure_date.formatted;
      }
      if (value.arrival_date && value.arrival_date.formatted) {
        this.selectedDate = value.arrival_date.jsdate;
        value.arrival_date = value.arrival_date.formatted;
      }

      this.getPlanning(value);
    });

    // For changes notification purpose
    // setInterval(() => {
    //   this.checkPlanning();
    // }, 10000)
  }

  /*checkPlanning(params?) {
    
    //console.log(params)
    
    params
      ? Object.assign(params, { month_date: this.selectedDate })
      : (params = { month_date: this.selectedDate });
    //console.log(params);
    this.service.getPlanning(params).subscribe((response) => {
      this.isLate = response.plannings.length !== this.plannings.length;
    });
  }*/
 
  getPlanning(params?) {
    this.full = 0;
    this.grouped = 0;
    this.monthly_margin = 0;
    this.lates = 0;
    this.todos = 0;
    // If there is params, add the month_date to them, else, create it.

    params
      ? Object.assign(params, { month_date: this.selectedDate })
      : (params = { month_date: this.selectedDate });
    
    params.page_number = this.page_number;

    params.unread = this.unread;
    params.unread_only = this.isUnreadFilterEnabled;

    this.service.getPlanning(params).subscribe((response) => {
      
      
      this.isLate = false;
      this.plannings = response.plannings;
      this.is_admin = response.is_admin;

      // Pagination Management
      this.plannings_count = parseInt(response.total_count); // Planning Count
      
      this.page_number = parseInt(response.page); // Current Page

      
      this.page_count = Math.ceil(this.plannings_count / 10); // Page Count
      // Page Indicators (for ngFor iterations)
      if (this.page_count < 10) {
        this.page_indicators = Array(this.page_count).fill(1);
      } else {
        this.page_indicators = Array(10).fill(1);
      }

      this.plannings.forEach(
        function (planning) {
          
          //formatta de gate pr my date picker en mod edit;
          let departure_date = new Date(planning.departure_date);
          let arrival_date = new Date(planning.arrival_date);

          planning.selectedDepartureDate = {
            year: departure_date.getFullYear(),
            month: departure_date.getMonth()+1,
            day: departure_date.getDate()
          }
          planning.selectedArrivalDate = {
            year: arrival_date.getFullYear(),
            month: arrival_date.getMonth()+1,
            day: arrival_date.getDate()
          }
          
          // Filtering the plannings Tasks
          planning.late = new Date(planning.departure_date) < new Date();
          planning.tasks = planning.tasks.filter((task) => (!task.checked && task.company_id == 0)); // To only keep the ones which are not done yet.
          if (planning.provider_payment_date)
            planning.provider_payment_date = {
              jsdate: new Date(planning.provider_payment_date),
            };
        }.bind(this)
      );

      this.service.getMonthlyStats(this.selectedDate).subscribe((response) => {
        this.todos = response.todos;
        this.lates = response.lates;
        this.full = response.full_count;
        this.grouped = response.grouped_count;
        this.monthly_margin = response.monthly_margin;
        this.unread = response.unread;
      });
    });
  }

  updatePlanningFiles(params: any) {
    let planning = this.plannings.find(p => p.id == params.planning_file.planning_id);
    if (planning) {
      if (params.isDeleted)
        planning.planning_files = planning.planning_files.filter(pf => pf.id != params.planning_file.id);
      else
        planning.planning_files.push(params.planning_file);
    }
  }
  
  updatePlanningChatData(planning_id: number) {
    this.planningMessagesService.getPlanningUserUnreadMessages(planning_id).subscribe(
      (response) => {
        //console.log("this.planningMessagesService.getPlanningUserUnreadMessages response:", response);
        let planning = this.plannings.find(p => p.id == planning_id);
        if (planning) planning.planning_unread_messages = response;
        if (!response.length) {
          this.unread = this.unread.filter(x => x != planning_id);
        } else if (this.unread.indexOf(planning_id) === -1) {
          this.unread.push(planning_id);
        }
      },
      (error) => {
        console.log("this.planningMessagesService.getPlanningUserUnreadMessages error:", error);
        this.toast.error(
          error.error && error.error.message 
            ? error.error.message 
            : `Une erreur est survenue lors de la récupération des messages non lus du planning`,
          false,
          "Récupération des messages non lus du planning"
        );
      }
    );
  }

  showUnread() {
    this.isUnreadFilterEnabled = !this.isUnreadFilterEnabled;
    this.page_number = 0;
    this.getPlanning();
  }

  // Previous Page Button
  previousPage() {

    this.page_number = this.page_number - 1;
    let params = this.filters.value;
    this.getPlanning(params);
  }

  // Next Page Button
  nextPage() {
    this.page_number = this.page_number + 1;
    let params = this.filters.value;
    this.getPlanning(params);
  }

  // Go to page n°nb
  toPage(nb: number) {
    if (nb != this.page_number) {
      this.page_number = nb;
      let params = this.filters.value;
      this.getPlanning(params);
    }
  }

  openConfirmModal(planning) {
    this.hanging_planning = planning;
    jQuery("#planning-mail-confirm-modal")
      .modal({ inverted: true })
      .modal("show");
  }

  sendMails() {
    this.service.sendTransportMail(this.hanging_planning.id).subscribe();
    jQuery("#planning-mail-confirm-modal")
      .modal({ inverted: true })
      .modal("hide");
  }

  sortBy(order: string) {
    this.order = order;
    var key = order.split(" ")[0];
    var way = order.split(" ")[1];

    if (["departure_date", "arrival_date"].indexOf(key) !== -1) {
      // Dateq
      if (way == "asc") {
        this.plannings.sort(function (a, b) {
          (a = a[key]), (b = b[key]);
          if (a && !b) return -1;
          if (!a && b) return 1;
          return new Date(a) < new Date(b)
            ? -1
            : new Date(a) > new Date(b)
            ? 1
            : 0;
        });
      } else {
        this.plannings.sort(function (a, b) {
          (a = a[key]), (b = b[key]);
          if (a && !b) return -1;
          if (!a && b) return 1;
          return new Date(a) > new Date(b)
            ? -1
            : new Date(a) < new Date(b)
            ? 1
            : 0;
        });
      }
    } else if (
      ["state", "buy_price", "sell_price", "quantity"].indexOf(key) !== -1
    ) {
      // Numberplannings
      if (way == "asc") {
        this.plannings.sort(function (a, b) {
          (a = parseFloat(a[key])), (b = parseFloat(b[key]));
          return a - b;
        });
      } else {
        this.plannings.sort(function (a, b) {
          (a = parseFloat(a[key])), (b = parseFloat(b[key]));
          return b - a;
        });
      }
    } else {
      // Stringplannings
      if (way == "asc") {
        this.plannings.sort(function (a, b) {
          if (a[key]) a = a[key].toUpperCase();
          if (b[key]) b = b[key].toUpperCase();
          if (a && !b) return -1;
          if (!a && b) return 1;
          return a < b ? -1 : a > b ? 1 : 0;
        });
      } else {
        this.plannings.sort(function (a, b) {
          if (a[key]) a = a[key].toUpperCase();
          if (b[key]) b = b[key].toUpperCase();
          if (a && !b) return -1;
          if (!a && b) return 1;
          return a > b ? -1 : a < b ? 1 : 0;
        });
      }
    }
  }

  // Month Selector
  selectMonth(month) {
    this.selectedDate.setMonth(month);
    this.getPlanning();
  }
  subYear() {
    this.selectedDate.setFullYear(this.selectedDate.getFullYear() - 1);
    this.getPlanning();
  }
  addYear() {
    this.selectedDate.setFullYear(this.selectedDate.getFullYear() + 1);
    this.getPlanning();
  }

  // Update
  updatePlanning(event, planning, column) {
    let inputs = event.target.parentElement.parentElement.getElementsByClassName(
      "edit-input"
    );
    let params = {};
    for (let input of inputs) {
      let name = input["name"];
      let value = input["value"];
      params[name] = value;
    }
    this.service.updatePlanning(planning.id, params).subscribe((response) => {
      // this.getPlanning();
    });
  }

  updateState(planning, event) {
    let params = {};
    params["state"] = event.target.value;

    this.service.updatePlanning(planning.id, params).subscribe((response) => {
      this.plannings.forEach(function (p) {
        if (p.id == planning.id) {
          p.state = event.target.value;
          return;
        }
      });
      // this.getPlanning();
    });
  }

  // Edition Input type text
  editInputMode(event) {
    if (event.target.parentElement.tagName == "SPAN") {
      // If Clicked on the Button
      var not_editing = event.target.parentElement.parentElement.getElementsByClassName(
        "not-editing"
      )[0];
      var editing = event.target.parentElement.parentElement.getElementsByClassName(
        "editing"
      )[0];
    } else if (event.target.parentElement.tagName == "BUTTON") {
      // If Clicked on the <i> in the Button
      var not_editing = event.target.parentElement.parentElement.parentElement.getElementsByClassName(
        "not-editing"
      )[0];
      var editing = event.target.parentElement.parentElement.parentElement.getElementsByClassName(
        "editing"
      )[0];
    } else if (event.target.tagName == "SPAN") {
      // If Double Clicked in the <td>
      var not_editing = event.target.parentElement.getElementsByClassName(
        "not-editing"
      )[0];
      var editing = event.target.parentElement.getElementsByClassName(
        "editing"
      )[0];
    } else {
      var not_editing = event.target.getElementsByClassName("not-editing")[0];
      var editing = event.target.getElementsByClassName("editing")[0];
    }

    if (not_editing && not_editing.style.display != "none") {
      // Only update the style if it's not in "Editing mode"
      not_editing.style = "display: none;";
      editing.style = "display: auto;";
    }

    editing.getElementsByClassName("edit-input")[0].focus();
    editing.getElementsByClassName("edit-input")[0].select();
  }

  // Valid Edition Input type text
  validInputEdit(event) {
    if (event.keyCode === 13) {
      event.target.parentElement.getElementsByTagName("BUTTON")[0].click();
    }
  }

  /*updateNote(planning_id, value) {
   
    var value = event.target.parentElement.getElementsByTagName("TEXTAREA")[0]
      .value;
    var params = {};
    params["note"] = value;
    this.service.updatePlanning(planning_id, params).subscribe((response) => {
      // this.getPlanning();
    });
  }*/
  updateRef(planning_id, event) {
    var value = event.target.parentElement.getElementsByTagName("TEXTAREA")[0]
      .value;
    var params = {};
    params["ref"] = value;
    this.service.updatePlanning(planning_id, params).subscribe((response) => {
      // this.getPlanning();
    });
  }
  // Expand Line
  manageExpand(event) {
    var icon_tag = event.target;
    if (icon_tag.classList.contains("down")) {
      // If Expanding
      icon_tag.classList.remove("down");
      icon_tag.classList.add("up");
      icon_tag.parentElement.parentElement.getElementsByClassName(
        "planning-tasks"
      )[0].style = "display: auto;";
    } else {
      // Folding
      icon_tag.classList.remove("up");
      icon_tag.classList.add("down");
      icon_tag.parentElement.parentElement.getElementsByClassName(
        "planning-tasks"
      )[0].style = "display: none;";
    }
  }

  // Edition Input type date
  editDateMode(event) {
    if (event.target.parentElement.tagName == "SPAN") {
      // If Clicked on the Button
      var not_editing = event.target.parentElement.parentElement.getElementsByClassName(
        "not-editing"
      )[0];
      var editing = event.target.parentElement.parentElement.getElementsByClassName(
        "editing"
      )[0];
    } else if (event.target.parentElement.tagName == "BUTTON") {
      // If Clicked on the <i> in the Button
      var not_editing = event.target.parentElement.parentElement.parentElement.getElementsByClassName(
        "not-editing"
      )[0];
      var editing = event.target.parentElement.parentElement.parentElement.getElementsByClassName(
        "editing"
      )[0];
    } else if (event.target.tagName == "SPAN") {
      // If Double Clicked in the <td>
      var not_editing = event.target.parentElement.getElementsByClassName(
        "not-editing"
      )[0];
      var editing = event.target.parentElement.getElementsByClassName(
        "editing"
      )[0];
    } else {
      var not_editing = event.target.getElementsByClassName("not-editing")[0];
      var editing = event.target.getElementsByClassName("editing")[0];
    }

    if (not_editing && not_editing.style.display != "none") {
      // Only update the style if it's not in "Editing mode"
      not_editing.style = "display: none;";
      editing.style = "display: auto;";
    }
  }

  // Valid Edit Input type date
  updateDepartureDate(event, planning) {
    this.service
      .updatePlanning(planning.id, {
        departure_date: new Date(event.jsdate).toLocaleDateString(),
      })
      .subscribe((response) => {
        // this.getPlanning();
      });
  }

  updateArrivalDate(event, planning) {
    this.service
      .updatePlanning(planning.id, {
        arrival_date: new Date(event.jsdate).toLocaleDateString(),
      })
      .subscribe((response) => {
        // this.getPlanning();
      });
  }

  updateProviderPaymentDate(event, planning) {
    //console.log(event);
    this.service
      .updatePlanning(planning.id, {
        provider_payment_date: new Date(event.jsdate).toLocaleDateString(),
      })
      .subscribe((response) => {
        // this.getPlanning();
      });
  }

  // Edition Input type company
  editCompanyMode(event) {
    if (event.target.parentElement.tagName == "SPAN") {
      // If Clicked on the Button
      var not_editing = event.target.parentElement.parentElement.getElementsByClassName(
        "not-editing"
      )[0];
      var editing = event.target.parentElement.parentElement.getElementsByClassName(
        "editing"
      )[0];
    } else if (event.target.parentElement.tagName == "BUTTON") {
      // If Clicked on the <i> in the Button
      var not_editing = event.target.parentElement.parentElement.parentElement.getElementsByClassName(
        "not-editing"
      )[0];
      var editing = event.target.parentElement.parentElement.parentElement.getElementsByClassName(
        "editing"
      )[0];
    } else if (event.target.tagName == "SPAN") {
      // If Double Clicked in the <td>
      var not_editing = event.target.parentElement.getElementsByClassName(
        "not-editing"
      )[0];
      var editing = event.target.parentElement.getElementsByClassName(
        "editing"
      )[0];
    } else {
      var not_editing = event.target.getElementsByClassName("not-editing")[0];
      var editing = event.target.getElementsByClassName("editing")[0];
    }

    if (not_editing && not_editing.style.display != "none") {
      // Only update the style if it's not in "Editing mode"
      not_editing.style = "display: none;";
      editing.style = "display: auto;";
    }
  }

  updateClient(company, planning) {
    this.service
      .updatePlanning(planning.id, { client_id: company.id })
      .subscribe((response) => {
        // this.getPlanning();
      });
  }

  updateTransporter(company, planning) {
    this.service
      .updatePlanning(planning.id, { transporter_id: company.id })
      .subscribe((response) => {
        // this.getPlanning();
      });
  }

  updatereceiver_id(company, planning) {
    this.service
      .updatePlanning(planning.id, { receiver_id: company.id })
      .subscribe((response) => {
        // this.getPlanning();
      });
  }

  // Edition Input type City
  editCityMode(event) {
    if (event.target.parentElement.tagName == "SPAN") {
      // If Clicked on the Button
      var not_editing = event.target.parentElement.parentElement.getElementsByClassName(
        "not-editing"
      )[0];
      var editing = event.target.parentElement.parentElement.getElementsByClassName(
        "editing"
      )[0];
    } else if (event.target.parentElement.tagName == "BUTTON") {
      // If Clicked on the <i> in the Button
      var not_editing = event.target.parentElement.parentElement.parentElement.getElementsByClassName(
        "not-editing"
      )[0];
      var editing = event.target.parentElement.parentElement.parentElement.getElementsByClassName(
        "editing"
      )[0];
    } else if (event.target.tagName == "SPAN") {
      // If Double Clicked in the <td>
      var not_editing = event.target.parentElement.getElementsByClassName(
        "not-editing"
      )[0];
      var editing = event.target.parentElement.getElementsByClassName(
        "editing"
      )[0];
    } else {
      var not_editing = event.target.getElementsByClassName("not-editing")[0];
      var editing = event.target.getElementsByClassName("editing")[0];
    }

    if (not_editing && not_editing.style.display != "none") {
      // Only update the style if it's not in "Editing mode"
      not_editing.style = "display: none;";
      editing.style = "display: auto;";
    }
  }

  updateDeparture(city, planning) {
    this.service
      .updatePlanning(planning.id, { departure_id: city.id })
      .subscribe((response) => {
        // this.getPlanning();
      });
  }

  updateArrival(city, planning) {
    this.service
      .updatePlanning(planning.id, { arrival_id: city.id })
      .subscribe((response) => {
        // this.getPlanning();
      });
  }

  copyPlanning(planning_id:number) {
    this.service.duplicatePlanning(planning_id).subscribe(response => {
      //console.log('Planning dupliqué avec succès', response);
      // this.plannings.push(response);
      this.getPlanning();
    }, error => {
      console.error('Erreur lors de la duplication du planning', error);
    });
  }

  toggleFilters() {
    jQuery('.sidebar_overlay').addClass('active');
    jQuery(".ui.sidebar").toggleClass("visible");
    this.enableTaskFilter();
  }
  closeSidebar() {
    jQuery('.sidebar_overlay').removeClass('active');
    jQuery(".ui.sidebar").removeClass("visible");
  }
  //affiche toutes les tasks dans la modal
  showAllTasks() {
    this.selectedPlanning = this.plannings;
    jQuery("#tasks-list-modal").modal({ inverted: true }).modal("show");
  }

  enableTaskFilter()
  {
    jQuery(".sidebar .ui.checkbox").checkbox();
  }
  resetFilters()
  {
    this.filters.reset();
    this.childCity.forEach((child) => { child.selectResult({ id: null, name: '' }) });
    this.childCountry.forEach((child) => { child.selectResult({ id: null, name: '' }) });
    this.childArea.forEach((child) => { child.selectResult({ id: null, name: '' }) });
    this.childCompany.forEach((child) => { child.selectResult({ id: null, name: '' }) });
    this.getPlanning();
  }

  async calculateCO2(planning) {
    //console.log('Calcul du CO2 pour le planning', planning);
    let departure_id = planning.departure_id;
    let arrival_id = planning.arrival_id;
    let qty = planning.quantity;
    let etapePorteur1 = planning.etape_porteur_1;
    let etapePorteur2 = planning.etape_porteur_2;
    
   
    const co2Emission = await this.co2Service.calculateCO2(departure_id, arrival_id, qty, etapePorteur1, etapePorteur2);

    //console.log('CO2 calculé', co2Emission);
    //save co2Emission in planning
    this.service.updatePlanning(planning.id, { co2_emis: co2Emission }).subscribe((response) => {
      //this.toast.success('Emissions CO2 sauvegardées', false, 'Planning');
      //console.log('Emissions CO2 sauvegardées', response);
      this.getPlanning();
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/planning/planning.component.ts